import { JavaAPIClient } from "../lib/apiHelper";

const { get, post, put, remove } = new JavaAPIClient();

export default {
    /**
     * 근로정보 조회
     * @param {*} companyId 
     * @returns 
     */
    list: companyId => get('/workSystem?companyId='+companyId),
    /**
     * 근로정보 추가
     * @param {*} workSystem 
     * @returns 
     */
    add: workSystem => post('/workSystem', workSystem),
    /**
     * 근로정보 수정
     * @param {*} workSystem 
     * @returns 
     */
    modify: workSystem => put('/workSystem', workSystem),
    /**
     * 근로정보 삭제
     * @param {*} id 
     * @returns 
     */
    delete: id => remove('/workSystem?id='+id),
}
